// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2snda","rootMobile":"styles_rootMobile__2Y5fp"};